export default __webpack_public_path__ + "/dist/images/privacypolicy-inactive.c5a4ea54116d2ad38d216f740d14a35e.svg";